import bind from "autobind-decorator";
let transition = null;
export default class Transition {

    constructor(el) {
        if (!transition) {
            Transition.detectTransition();
        }
        this.transitions = {};
        this.$el = $(el);
        this.count = 0;
    }

    push(css, useTransitionEnd = true) {
        return this._add('push', css, useTransitionEnd);
    }

    pop(css, useTransitionEnd = true) {
        return this._add('pop', css, useTransitionEnd);
    }

    _add(type, css, useTransitionEnd) {
        const push = type == 'push';
        const key = `${type}-${css}`;
        const hasClass = this.$el.hasClass(css);

        if (this._pushes(css) || this._poppes(css)) {
            return new Promise((resolve, reject) => (reject()));
        }
        // XOR
        if (hasClass == push) {
            //1. hasClass and is pushing
            //2. doesn't have class and is popping
            return new Promise((resolve, reject) => (resolve()));
        }
        console.log(key, useTransitionEnd);

        const p = new Promise((resolve, reject) => {
            this.count++;
            this.transitions[key] = p;
            const handleTransitionEnd = () => {
                this.count--;
                this.$el.off(transition, handleTransitionEnd);
                if (this.count <= 0) {
                    this.$el.removeClass('is-transitioning');
                }
                if (push) {
                    this.$el.removeClass(`before-${css}`);
                }else{
                    this.$el.removeClass(`after-${css}`);

                }
                delete this.transitions[key];
                resolve();
            };
            this.$el.addClass('is-transitioning');
            if (push) {
                this.$el.addClass(`before-${css}`);
            }else{
                this.$el.addClass(`after-${css}`);

            }
            if (useTransitionEnd) {
                this.$el.on(transition, handleTransitionEnd);
            }
            this.repaint();
            this.$el[push ? 'addClass' : 'removeClass'](css);
            if (!useTransitionEnd) {
                handleTransitionEnd();
            }
        });
        return p;
    }

    repaint() {
        this.$el[0].offsetHeight;
    }

    _pushes(css) {
        return this.transitions[`push-${css}`] !== undefined;
    }

    _poppes(css) {
        return this.transitions[`pop-${css}`] !== undefined;
    }

    @bind
    handleTransitionEnd() {
        this.$el.removeClass('is-transitioning');
    }

    static detectTransition() {
        const transitions = {
            'transition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd',
            'MozTransition': 'transitionend',
            'OTransition': 'oTransitionEnd otransitionend'
        };

        for (let t in transitions) {
            if (document.body.style[t] !== undefined) {
                transition = transitions[t];
                break;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./assets/js/Transition.js